var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Emit, Prop, Component } from 'vue-property-decorator';
import { Dependencies } from '~/core/decorator';
import { DataImportExcelInfoService } from '~/services/dataimp-service/data-import-excel-info.service';
var CaseBatchDelete = /** @class */ (function (_super) {
    __extends(CaseBatchDelete, _super);
    function CaseBatchDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteModel = {
            batchNumber: '',
        };
        _this.rules = {
            batchNumber: { required: true, message: "请选择要删除的案件批次号！" }
        };
        _this.steplength = 0;
        return _this;
    }
    CaseBatchDelete.prototype.emitSuccess = function () {
        this.$message.success('案件删除成功');
        this.emitClose();
    };
    CaseBatchDelete.prototype.emitClose = function () {
        var form = this.$refs.form;
        form.resetFields();
    };
    /**
     * 案件选择批次号删除
     */
    CaseBatchDelete.prototype.deleteCase = function () {
        var _this = this;
        var form = this.$refs.form;
        form.validate(function (v) {
            if (!v)
                return;
            _this.dataImportExcelInfoService
                .deleteDataExcelInfoByBatch(_this.deleteModel)
                .subscribe(_this.emitSuccess);
        });
    };
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], CaseBatchDelete.prototype, "dataImportExcelInfoService", void 0);
    __decorate([
        Prop()
    ], CaseBatchDelete.prototype, "batchList", void 0);
    __decorate([
        Emit("success")
    ], CaseBatchDelete.prototype, "emitSuccess", null);
    __decorate([
        Emit("close")
    ], CaseBatchDelete.prototype, "emitClose", null);
    CaseBatchDelete = __decorate([
        Component({})
    ], CaseBatchDelete);
    return CaseBatchDelete;
}(Vue));
export default CaseBatchDelete;
